'use client';
/**
 * Инвариант, асинхронно производящий экземпляр ошибки.
 *
 * @param condition - Условие, при выполнении которого выбрасывается ошибка.
 * @param factory - Фабрика, производящая Promise над экземпляром ошибки. Ошибка может быть произведена асинхронно.
 *
 * @primaryExample
 * await invariant(requestFailed, () => asyncDecorate(new HTTPError()));
 *
 * @stable
 * */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const invariant = /*#__PURE__*/ _async_to_generator(function*(condition, factory) {
    if (condition) {
        throw yield factory();
    }
});

export { invariant };
//# sourceMappingURL=invariant.js.map
